// extracted by mini-css-extract-plugin
export default {"postsPage":"postsPage_AR3yx","posts":"posts_Q11cd"};